import { UnitSelect } from 'components/template/TemplateForm';
import { TimeInput } from 'components/template/TemplateForm';
import { RateInput } from 'components/template/TemplateForm';
import moment from 'moment';
import React, { useEffect } from 'react'
import { Controller } from 'react-hook-form';
import { useDispatch, useSelector } from "react-redux";
import { fetchLanguages } from "slices/languageSlice";
import { AsyncPaginate } from "react-select-async-paginate";
import { selectCustomStyles } from "components/common/Select";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import { useTranslation } from 'react-i18next';
const RatesSection = ({ title, control, errors, prefix }) => {
    const { t } = useTranslation();
    const opiLabel = t('interpreter.opiVri');
    const inPersonLabel = t('interpreter.inPerson');
    return (
        <div className='row-primary rate_container_outer'>
            <h2 className='fw-bold text-uppercase'>{title}</h2>
            <div className='w-100'>
                {['normal', 'after'].map((time) => (
                    <div key={time}>
                        <h2 className='text-center my-3 fw-bold fst-italic'>{time === 'normal' ? t('interpreter.normalHours') : t('interpreter.afterHours')}*</h2>

                        <div className="template_create rate_container">
                            <div className="row-primary align-items-end inner">
                                <h2 className='mb-3 my-0'>{t('interpreter.ratesLabel')}</h2>
                                {['opi_vri', 'inperson'].map((type) => (
                                    <div className='Inter_rate_row' key={type}>
                                        <h4>{type === 'opi_vri' ? opiLabel : inPersonLabel}</h4>
                                        <div className='create inter inter_wrapper'>
                                            <RateInput control={control} name={`${prefix}_${type}_${time}_rate`} placeholder={`${type === 'opi_vri' ? opiLabel : inPersonLabel} ${t('interpreter.rate')}`} currency_symbol={true} />
                                            <UnitSelect control={control} name={`${prefix}_${type}_${time}_rate_time_unit`} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="row-primary align-items-end inner">
                                <h2 className='mb-3 my-0'>{t('interpreter.minimumLabel')}</h2>
                                {['opi_vri', 'inperson'].map((type) => (
                                    <div className='Inter_rate_row' key={type}>
                                        <div className='create inter inter_wrapper'>
                                            <RateInput errors={errors} control={control} name={`${prefix}_${type}_${time}_min`} placeholder={`${type === 'opi_vri' ? opiLabel : inPersonLabel} ${t('interpreter.minimum')}`} />
                                            <UnitSelect control={control} name={`${prefix}_${type}_${time}_min_time_unit`} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}

            </div>
        </div>
    );
};



const InterpreterRateSection = ({ control, errors, watch, ErrorMessage, setValue }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    useEffect(() => {
        const rates = watch('rates');
        if (!rates || rates.length === 0) {
            setValue('rates', [
                {
                    id: Date.now(),
                    language_ids: []
                }
            ]);
        }
    }, []);
    const handleNormalHoursChange = () => {
        const normalHourStartTime = watch("normal_hour_start_time");
        const normalHourEndTime = watch("normal_hour_end_time");

        if (normalHourStartTime && normalHourEndTime) {
            const normalStart = moment(normalHourStartTime, "HH:mm");
            const normalEnd = moment(normalHourEndTime, "HH:mm");

            const afterStart = moment(normalEnd).add(1, "minutes");
            const afterEnd = moment(normalStart).subtract(1, "minutes").add(1, "day");

            setValue("after_hour_start_time", afterStart.format("HH:mm"));
            setValue("after_hour_end_time", afterEnd.format("HH:mm"));
        }
    };

    const getAllSelectedLanguageIdsExceptCurrent = (currentIndex) => {
        const rates = watch('rates') || [];

        return rates
            .filter((_, index) => index !== currentIndex)
            .flatMap(rate => rate.language_ids || [])
            .map(lang => lang.value);
    };

    const handleAfterHoursChange = () => {
        const afterHourStartTime = watch("after_hour_start_time");
        const afterHourEndTime = watch("after_hour_end_time");

        if (afterHourStartTime && afterHourEndTime) {
            const afterStart = moment(afterHourStartTime, "HH:mm");
            const afterEnd = moment(afterHourEndTime, "HH:mm");

            const normalStart = moment(afterEnd).add(1, "minutes").subtract(1, "day");
            const normalEnd = moment(afterStart).subtract(1, "minutes");

            setValue("normal_hour_start_time", normalStart.format("HH:mm"));
            setValue("normal_hour_end_time", normalEnd.format("HH:mm"));
        }
    };
    const [rateLanguages, setRateLanguages] = React.useState([
        { id: Date.now() }
    ]);

    const addMoreLanguage = () => {
        setValue('rates' ,[...watch('rates'), { id: Date.now() }]);
    };

    const removeLanguage = (id) => {
        setValue('rates', watch('rates').filter(item => item.id !== id));
    };
    const filteredLanguagesLoadOptions = (currentIndex) => async (
        inputValue,
        loadedOptions,
        { page }
        ) => {
        const result = await dispatch(
            fetchLanguages(
            page,
            {
                pageLength: 20,
                sortBy: "id",
                sortDirection: "asc",
                search: inputValue,
            },
            true,
            true
            )
        );

        const selectedLanguageIds =
            getAllSelectedLanguageIdsExceptCurrent(currentIndex);

        return {
            options: result?.data
            ?.filter(lang => !selectedLanguageIds.includes(lang.id))
            .map(language => ({
                value: language.id,
                label: language.name,
            })),
            hasMore: page !== result?.last_page,
            additional: {
            page: page + 1,
            },
        };
    };
    return (
        <>
            <hr />
            {/* Normal Hours */}
            <div className="row-primary m-0 row-r justify-content-between flex-row">
                <h2 className='fst-italic fw-bold mt-0'>{t('interpreter.normalHours')}</h2>
            </div>
            <div className="template foam_page_row">
                <div className="row-primary">
                    <h2>{t('interpreter.startTime')}</h2>
                    <TimeInput
                        errors={errors}
                        control={control}
                        name="normal_hour_start_time"
                        rule={t('interpreter.selectStartTime')}
                        onChange={handleNormalHoursChange}
                    />
                </div>

                <div className="row-primary">
                    <h2>{t('interpreter.endTime')}</h2>
                    <TimeInput
                        errors={errors}
                        control={control}
                        name="normal_hour_end_time"
                        rule={t('interpreter.selectEndTime')}
                        onChange={handleNormalHoursChange}
                    />
                </div>
            </div>

            {/* After Hours */}
            <div className="row-primary m-0 row-r justify-content-between flex-row">
                <h2 className='fst-italic fw-bold mt-0'>{t('interpreter.afterHours')}</h2>
            </div>
            <div className="template foam_page_row">
                <div className="row-primary">
                    <h2>{t('interpreter.startTime')}</h2>
                    <TimeInput
                        errors={errors}
                        control={control}
                        name="after_hour_start_time"
                        rule={t('interpreter.selectStartTime')}
                        onChange={handleAfterHoursChange}
                    />
                </div>

                <div className="row-primary">
                    <h2>{t('interpreter.endTime')}</h2>
                    <TimeInput
                        errors={errors}
                        control={control}
                        name="after_hour_end_time"
                        rule={t('interpreter.selectEndTime')}
                        onChange={handleAfterHoursChange}
                    />
                </div>
            </div>


            {/* Grace Period */}
            <div className='template foam_page_row mt-sm-3'>
                <div className="row-primary">
                    <h2>{t('interpreter.cancelGracePeriodHrs')}</h2>
                    <div style={{ width: "100%" }}>
                        <Controller
                            name="grace_period"
                            control={control}
                            rules={{ required: t('interpreter.enterGracePeriod') }}
                            render={({ field }) => (
                                <input className="input-in type_inp"
                                    type="number"
                                    name='grace_period'
                                    placeholder={t('interpreter.gracePeriod')} required
                                    {...field}
                                    onChange={
                                        (e) => {
                                            field.onChange(parseFloat(e.target.value));
                                            if (e.target.value < 0) {
                                                field.onChange(0);
                                            }
                                        }
                                    }
                                />
                            )}
                        />
                        {errors?.grace_period?.message && <div style={{ marginBottom: 10 }}><ErrorMessage text={errors?.grace_period?.message} /></div>}
                    </div>
                </div>
            </div>
            <div className="row-primary mt-3 mb-5 justify-content-center">
                <h2 className="fw-bold text-center text-uppercase">{t('interpreter.rates')}</h2>
            </div>
            {/* <RatesSection title={t('interpreter.generalRates')} control={control} errors={errors} prefix='general' />
            <RatesSection title={t('interpreter.courtRates')} control={control} errors={errors} prefix='court' />
            <RatesSection title={t('interpreter.medicalRates')} control={control} errors={errors} prefix='medical' /> */}

            {watch('rates').map((item, index) => (
                <div key={item.id} className="rate-language-wrapper">
                    <div className="row-primary align-items-center justify-content-between">
                        <div style={{ flex: 1 }}>
                            <div style={{ display: "flex" }}>
                                <h2>{t('interpreter.selectLanguages')}</h2>
                                <Controller
                                    name={`rates.${index}.language_ids`}
                                    control={control}
                                    rules={{
                                        validate: (value) =>
                                        value && value.length > 0 || t('interpreter.selectAtLeastOneLanguage')
                                    }}
                                    render={({ field }) => (
                                        <AsyncPaginate
                                            menuPlacement="auto"
                                            isMulti
                                            styles={selectCustomStyles}
                                            value={field.value || []}
                                            // loadOptions={filteredLanguagesLoadOptions}
                                            loadOptions={filteredLanguagesLoadOptions(index)}
                                            isClearable
                                            escapeClearsValue
                                            onChange={(selected) => field.onChange(selected)}
                                            additional={{ page: 1 }}
                                        />
                                    )}
                                />
                            </div>
                        </div>

                        {watch('rates').length > 1 && (
                            <div>
                                <SubmitButton
                                    buttonType="button"
                                    className={"tomatoRed"}
                                    btnText={t('common.delete')}
                                    handleSubmit={() => removeLanguage(item.id)}
                                />
                            </div>
                        )}
                    </div>
                    {errors?.rates?.[index]?.language_ids && (
                    <div style={{ marginTop: 6 }}>
                        <ErrorMessage text={errors.rates[index].language_ids.message} />
                    </div>
                    )}

                    {watch(`rates.${index}.language_ids`)?.length > 0 && (
                        <>
                            <RatesSection
                                title={t('interpreter.generalRates')}
                                control={control}
                                errors={errors}
                                prefix={`rates.${index}.general`}
                            />
                            <RatesSection
                                title={t('interpreter.courtRates')}
                                control={control}
                                errors={errors}
                                prefix={`rates.${index}.court`}
                            />
                            <RatesSection
                                title={t('interpreter.medicalRates')}
                                control={control}
                                errors={errors}
                                prefix={`rates.${index}.medical`}
                            />
                            <RatesSection
                                title={t('interpreter.legalRates')}
                                control={control}
                                errors={errors}
                                prefix={`rates.${index}.legal`}
                            />
                        </>
                    )}
                </div>
            ))}
            
            <div className="row-primary mt-3">
            <SubmitButton
                buttonType="button"
                className={"lightBlue"}
                btnText={t('interpreter.addMoreLanguageRates')}
                handleSubmit={addMoreLanguage}
            />
            </div>
        </>
    )
}

export default InterpreterRateSection